import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { RichText } from '../rich-text/rich-text.esm.js';

/**
 * If there is no as value explitly defined then we should use the render value
 */ const getValidAs = (render, as)=>{
    const validAs = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p'
    ];
    const invalidRender = [
        'display-1',
        'display-2',
        'display-3',
        'display-4',
        'display-5',
        'display-6'
    ];
    if (!invalidRender.includes(render) && !as) {
        return render;
    }
    if (as && validAs.includes(`${as}`)) {
        return as;
    }
    return 'p';
};
const Title = ({ render, as, className, ...rest })=>{
    const Component = getValidAs(render, as);
    return jsx(RichText, {
        as: Component,
        className: classNames('d-inline', {
            [render]: render && as
        }, className),
        ...rest
    });
};

export { Title };
